/*
 * Verifications Dashboard  Messages
 *
 * This contains all the text for the Verifications Page component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.VerificationsPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Verifications',
  },
  searchUidPlaceholder: {
    id: `${scope}.searchUidPlaceholder`,
    defaultMessage: 'UID',
  },
  searchNamePlaceholder: {
    id: `${scope}.searchNamePlaceholder`,
    defaultMessage: 'Name',
  },
  UIDLabel: {
    id: `${scope}.UIDLabel`,
    defaultMessage: 'UID',
  },
  studentNameLabel: {
    id: `${scope}.studentNameLabel`,
    defaultMessage: 'Student Name',
  },
  uploadedAtLabel: {
    id: `${scope}.uploadedAtLabel`,
    defaultMessage: 'Uploaded at',
  },
  noDataMessage: {
    id: `${scope}.noDataMessage`,
    defaultMessage: 'There’s no more document to verify for now.',
  },
  refreshListButton: {
    id: `${scope}.refreshListButton`,
    defaultMessage: 'Refresh the list',
  },
  languageLabel: {
    id: `${scope}.languageLabel`,
    defaultMessage: 'Language',
  },
  createdAtLabel: {
    id: `${scope}.createdAtLabel`,
    defaultMessage: 'Created at',
  },
  pendingLabel: {
    id: `${scope}.pendingLabel`,
    defaultMessage: 'Pending',
  },
  approvedLabel: {
    id: `${scope}.approvedLabel`,
    defaultMessage: 'Approved',
  },
  rejectedLabel: {
    id: `${scope}.rejectedLabel`,
    defaultMessage: 'Rejected',
  },
  approvalDone: {
    id: `${scope}.approvalDone`,
    defaultMessage: 'Approval done successfully',
  },
  declineDone: {
    id: `${scope}.declineDone`,
    defaultMessage: 'Decline done successfully',
  },
  withProofSwitchLabel: {
    id: `${scope}.withProofSwitchLabel`,
    defaultMessage: 'With Proof',
  },
  noProofSwitchLabel: {
    id: `${scope}.noProofSwitchLabel`,
    defaultMessage: 'No Proof',
  },
  onlyWithVideoSwitchLabel: {
    id: `${scope}.onlyWithVideoSwitchLabel`,
    defaultMessage: 'Only with Video',
  },
  allVideoSwitchLabel: {
    id: `${scope}.allVideoSwitchLabel`,
    defaultMessage: 'All',
  },
  fileDownloaded: {
    id: `${scope}.fileDownloaded`,
    defaultMessage: 'File downloaded',
  },
});
